
      import { defu } from 'defu'
      const matcher = /* @__PURE__ */ (() => { const $0={prerender: true};; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1)||"/";if(p==="/"){r.unshift({data:$0});}return r;}})()
      export default (path) => defu({}, ...matcher('', typeof path === 'string' ? path.toLowerCase() : path).map(r => r.data).reverse())
      